import script from "./CButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CButton.vue?vue&type=script&setup=true&lang=ts"

import "./CButton.vue?vue&type=style&index=0&id=9d5acd9a&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ldcloud\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d5acd9a"]])

export default __exports__